module.exports = __webpack_public_path__ + "img/mainpro2.718bf83c.png";